import styled from "styled-components"

interface ReportElementBanner {
  bgImagen?: string
  selectOpen?: boolean
}

export const ReportElementBanner = styled.div`
  background-image: url(${(p: ReportElementBanner) => p.bgImagen ? p.bgImagen : ""});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  width: 100%;
  height: 170px;
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  -webkit-transition: all 300ms ease 0ms;
  -o-transition: all 300ms ease 0ms;
  transition: all 300ms ease 0ms;
  font-family: MontserratRegular;
 
  @media (max-width: 780px) {
    padding: 0.5rem;
    justify-content: start;
    flex-direction: column;
    align-items: start;
    height: ${(p: ReportElementBanner) => p.selectOpen ? "190px" : "160px"};
  }
`

export const ReportContainerTitle = styled.div`
  background: transparent;
  width: 60%;
  height: 150px;
  padding: 2rem;
  display: flex;
  justify-content: start;
  align-items: center;

  @media (max-width: 780px) {
    width: 100%;
    height: 80px;
  }
`

export const ReportContainerSelector = styled.div`
  background: transparent;
  width: 40%;
  height: 150px;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: MontserratRegular;

  @media (max-width: 780px) {
    width: 100%;
    height: 70px;
    padding: 2rem 1rem 2rem 1rem;
  }
`

interface ReportElementBannerTitle {
  textColor?: string
}

export const ReportElementBannerTitle = styled.h1`
  font-size: 4.1rem;
  color: ${(p: ReportElementBannerTitle) => p.textColor ? p.textColor : "var(--color-text)"};

  @media (max-width: 780px) {
    font-size: 2.1rem;
  }
`

interface ReportElementContainer {
  bg?: string
}

export const ReportElementContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 2rem;
  background-color: ${(p: ReportElementContainer) => p.bg ? p.bg : "var(--color-menu-bg)"};
  padding: 1rem;
  justify-items: center;
  margin-bottom: 135px;

  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

interface ReportElementListContainer {
  bg?: string
}

export const ReportElementListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p: ReportElementListContainer) => p.bg ? p.bg : "var(--color-menu-bg)"};
  padding: 1rem;
  padding-left: 14rem; 
  padding-right: 14rem;
  justify-items: center;
  margin-bottom: 35px;

  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
    padding-left: 1rem; 
    padding-right: 1rem;
  }
`

interface ReportContainerSelect {
  isVisible: boolean
}

export const ReportContainerSelect = styled.div`
  background: transparent;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: end;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-transition: all 300ms ease 0ms;
  -o-transition: all 300ms ease 0ms;
  transition: all 300ms ease 0ms;

  @media (max-width: 780px) {
    display: ${(p: ReportContainerSelect) => p.isVisible ? "flex" : "none"};
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    width: 90%;
  }
`

interface Label {
  textColor?: string
}

export const Label = styled.label`
  width: 30%;
  color: ${(p: Label) => p.textColor ? p.textColor : "var(--color-text)"};
  display: block;
  font-size: clamp(1.2rem, 2.5vw, 1rem);
  font-weight: 600;
  margin-right: 10px;
  margin-left: 10px;
  text-align: right;
  padding: 0;

  @media (max-width: 780px) {
    display: none;
    text-align: left;
    width: 100%;
  }
`

export const InputSelect = styled.select`
  width: 50%;
  color: var(--color-text);
  cursor: pointer;
  height: 2rem;
  display: block;
  font-size: clamp(1rem, 2.5vw, 1rem);
  border-radius: 52px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  padding: 0.2rem 0.7rem;

  @media (max-width: 780px) {
    width: 100%;
  }
`

interface IconListButton {
  bg?: string
}

export const IconListButton = styled.label`
  background-color: ${(p: IconListButton) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: #ffffff;
  display: flex;
  flex-direction: row;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 5px 0 5px;
  border-radius: 52px;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  @media (max-width: 780px) {
    height: 2.2rem;
  }
`

interface SelectReportButton {
  bg?: string
}

export const SelectReportButton = styled.label`
  background-color: ${(p: SelectReportButton) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: #ffffff;
  display: none;
  flex-direction: row;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 5px 0 5px;
  border-radius: 52px;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  @media (max-width: 780px) {
    display: flex;
    height: 2.2rem;
  }
`

interface BackButton {
  bg?: string
  selectOpen?: boolean
}

export const BackButton = styled.label`
  background-color: ${(p: BackButton) => (p.bg ? p.bg : "var(--color-rosa)")};
  color: #ffffff;
  display: flex;
  flex-direction: row;
  width: 3rem;
  height: 3rem;
  border-radius: 52px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: absolute;
  box-shadow: 0px 3px 6px #00000029;
  top: 130px;
  left: 65px;
	z-index: 2;
  -webkit-transition: all 300ms ease 0ms;
  -o-transition: all 300ms ease 0ms;
  transition: all 300ms ease 0ms;

  @media (max-width: 780px) {
    top: ${(p: ReportElementBanner) => p.selectOpen ? "150px" : "120px"};
    left: 35px;
  }
`